import { Moment } from "moment";

export type TimeWindowRange = {
  startMinutes: number;
  endMinutes: number;
};

export const momentToClockMinutes = (m: Moment): number =>
  m.hours() * 60 + m.minutes();

const intervalFitsWindow = (
  layoutStartMinutes: number,
  layoutEndMinutes: number,
  window: TimeWindowRange
): boolean =>
  layoutStartMinutes >= window.startMinutes &&
  layoutEndMinutes <= window.endMinutes;

/**
 * Returns true when the layout interval fits entirely within the template
 * window that contains scheduledStart (same workOrderTemplateId). Falls back
 * to any matching template window when scheduled start is outside all windows.
 * Returns true (no constraint) when workOrderTemplateId is absent or that
 * template has no windows in templateWindowsById.
 */
export const layoutIntervalFitsBelongingTemplateWindow = (
  workOrderTemplateId: string | undefined,
  layoutStart: Moment,
  layoutEnd: Moment,
  scheduledStart: Moment,
  templateWindowsById: Record<string, TimeWindowRange[]>
): boolean => {
  if (!workOrderTemplateId) return true;
  const windows = templateWindowsById[workOrderTemplateId];
  if (!windows?.length) return true;

  const layoutStartMinutes = momentToClockMinutes(layoutStart);
  const layoutEndMinutes = momentToClockMinutes(layoutEnd);
  const scheduledMinutes = momentToClockMinutes(scheduledStart);

  const belongingWindow = windows.find(
    (w) => scheduledMinutes >= w.startMinutes && scheduledMinutes < w.endMinutes
  );

  if (belongingWindow) {
    return intervalFitsWindow(
      layoutStartMinutes,
      layoutEndMinutes,
      belongingWindow
    );
  }

  return windows.some((w) =>
    intervalFitsWindow(layoutStartMinutes, layoutEndMinutes, w)
  );
};
